"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var _ = tslib_1.__importStar(require("@antv/util"));
var ApplyResponsive = /** @class */ (function () {
    function ApplyResponsive(cfg) {
        _.assign(this, cfg);
        this.init();
    }
    ApplyResponsive.prototype.init = function () {
        this.type = this.getType();
        if (this.shouldApply()) {
            this.apply();
        }
    };
    return ApplyResponsive;
}());
exports.default = ApplyResponsive;
//# sourceMappingURL=base.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/g2plot/lib/util/responsive/apply/base.js
// module id = 628
// module chunks = 37